import { Modal } from "antd"

export const ssnDigits = (ssn) => `${ssn || ""}`.replace(/[^\d]/g, "").trim()

export const hasFilledPresentResidentialAddress = (person) => {
    const addr = person?.presentAddress || {}
    return `${addr.street || addr.address || ""}`.trim() !== ""
}

export const participantDisplayName = (person) => (
    [person?.firstName, person?.middleName, person?.lastName]
        .filter(Boolean)
        .join(" ")
    || "Borrower"
)

/** Missing SSN / current residential address for borrowers about to be pulled. */
export function listCreditPullProfileGaps(subjects) {
    return (subjects || []).map((participant) => {
        const missing = []
        if (!ssnDigits(participant?.socialSecurity)) missing.push("SSN")
        if (!hasFilledPresentResidentialAddress(participant)) missing.push("Current residential address")
        if (!missing.length) return null
        return {
            partyId: participant?.partyId,
            name: participantDisplayName(participant),
            missing,
        }
    }).filter(Boolean)
}

export function listCreditPullProfileGapsForPartyIds(application, partyIds) {
    const byId = application?.participantsById || {}
    const seen = new Set()
    const subjects = []
    ;(partyIds || []).forEach((partyId) => {
        if (!partyId || seen.has(partyId)) return
        seen.add(partyId)
        const person = byId[partyId]
        if (person) subjects.push(person)
    })
    return listCreditPullProfileGaps(subjects)
}

export function partyIdsFromPaymentLineItems(lineItems) {
    const ids = []
    ;(lineItems || []).forEach((item) => {
        ;(item?.partyIds || item?.PartyIDs || []).forEach((id) => {
            if (id) ids.push(id)
        })
    })
    return ids
}

export function showCreditPullProfileGapWarning(gaps, intro) {
    Modal.warning({
        title: "Missing information",
        content: (
            <div>
                <p style={{ marginBottom: 8 }}>
                    {intro || "Fill in SSN and Current residential address before continuing."}
                </p>
                <ul style={{ marginBottom: 0, paddingLeft: 20 }}>
                    {(gaps || []).map((gap) => (
                        <li key={gap.partyId || gap.name}>
                            <strong>{gap.name}</strong>
                            {`: ${gap.missing.join(", ")}`}
                        </li>
                    ))}
                </ul>
            </div>
        ),
    })
}
